// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {perr} from 'hola_pub_util';
import {i_geo_location, i_instruction} from '../sessions';

// Create a base interface for saved task data
interface i_saved_task_data {
    name: string;
    instructions: i_instruction[];
    type: string;
    cron_settings: string;
    project: string;
    geoLocation: i_geo_location;
}

// i_saved_task_item extends the base with id and timestamps
export interface i_saved_task_item extends i_saved_task_data {
    id: string;
    created: string;
    updated?: string;
}

// i_create_saved_task_params makes some fields optional
export type i_create_saved_task_params
= Omit<i_saved_task_data, 'project' | 'geoLocation'> & {
    project?: string;
    geoLocation?: i_geo_location;
};

// i_update_saved_task_params makes all fields optional and adds saved_task_id
type i_update_saved_task_params = {
    task_id: string;
} & Partial<i_create_saved_task_params>;

// API functions
const get_saved_tasks = ()=>etask(function*(){
    try {
        const res = yield fetch('/api/v1/saved_tasks');
        return res;
    } catch(e){
        console.error('Error fetching saved tasks:', e);
        return {error: 'unknown'};
    }
});

const get_saved_task_by_id = (saved_task_id: string)=>etask(function*(){
    try {
        const res = yield fetch(`/api/v1/saved_tasks/${saved_task_id}`);
        return res;
    } catch(e){
        console.error('Error fetching saved task by id:', e);
        return {error: 'unknown'};
    }
});

const get_saved_tasks_by_name = (name: string)=>etask(function*(){
    try {
        const res = yield fetch('/api/v1/saved_tasks/name/'
            +encodeURIComponent(name));
        return res;
    } catch(e){
        console.error('Error fetching saved tasks by name:', e);
        return {error: 'unknown'};
    }
});

const create_saved_task = (params: i_create_saved_task_params)=>
    etask(function*(){
    try {
        perr({id: 'create_saved_task_in_the_bank'});
        const res = yield fetch('/api/v1/saved_tasks', {
            method: 'POST',
            json: true,
            body: params,
        });
        return res;
    } catch(e){
        console.error('Error creating saved task:', e);
        return {error: 'unknown'};
    }
});

const update_saved_task = (params: i_update_saved_task_params)=>
    etask(function*(){
    try {
        const {task_id, ...update_data} = params;
        perr({id: 'update_saved_task_in_the_bank'});
        const res = yield fetch(`/api/v1/saved_tasks/${task_id}`, {
            method: 'PUT',
            json: true,
            body: update_data,
        });
        return res;
    } catch(e){
        console.error('Error updating saved task:', e);
        return {error: 'unknown'};
    }
});

const delete_saved_task = (task_id: string)=>etask(function*(){
    try {
        perr({id: 'delete_saved_task_in_the_bank'});
        const res = yield fetch(`/api/v1/saved_tasks/${task_id}`, {
            method: 'DELETE',
        });
        return res;
    } catch(e){
        console.error('Error deleting saved task:', e);
        return {error: 'unknown'};
    }
});

export const saved_tasks_api = {
    get_saved_tasks,
    get_saved_task_by_id,
    get_saved_tasks_by_name,
    create_saved_task,
    update_saved_task,
    delete_saved_task,
};
